module.exports = __webpack_public_path__ + "img/xmark.5f919e46.svg";